<template lang="pug">
  .buttons
    button.button.button_music(
      @click="$emit('music')",
      :class="{ 'button_music-off' : !isPlaying }")
    button.button.button_pause(@click="$emit('pause')")
</template>

<script>
export default {
  name: 'Controls',
  props: ['isPlaying'],
};
</script>

<style scoped lang="scss">
  .button {
    @include vertical-align;
    justify-content: center;
    border: none;
    background-color: transparent;
    @include retina-sprite($interface-icon-bg-group);
    &:after {
      @include pseudo;
    }
    @media (max-width: $max-width-xs) {
      @include retina-sprite($interface-icon-bg-xs-group);
    }
    &_pause {
      margin-left: 16px;
      &:after {
        @include retina-sprite($interface-icon-pause-group);
      }
      @media (max-width: $max-width-xs),
        (-moz-touch-enabled: 1),
        (pointer: coarse) {
        margin: 12px 0 0;
        &:after {
          @include retina-sprite($interface-icon-pause-xs-group);
        }
      }
    }
    &_music {
      &:after,
      &:before {
        @include trans;
      }
      &:after {
        @include retina-sprite($interface-icon-music-group);
      }
      &:before {
        @include pseudo;
        @include retina-sprite($interface-icon-music-off-group);
        opacity: 0;
      }
      @media (max-width: $max-width-xs) {
        &:after {
          @include retina-sprite($interface-icon-music-xs-group);
        }
        &:before {
          @include retina-sprite($interface-icon-music-off-xs-group);
        }
      }
      &-off {
        &:after {
          opacity: 0;
        }
        &:before {
          opacity: 1;
        }
      }
    }
    &s {
      @include vertical-align;
      justify-content: flex-end;
      @media (max-width: $max-width-xs),
        (-moz-touch-enabled: 1),
        (pointer: coarse) {
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Interface/Buttons.vue